import { Outlet } from 'react-router';
import { AuthGuard } from '@/components/AuthGuard';
import { AuthShell } from '@/components/shell';

export default function AuthLayout() {
  return (
    <AuthGuard isAuthRequired={false}>
      <AuthShell>
        <Outlet />
      </AuthShell>
    </AuthGuard>
  );
}
